import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Puneweeendtourpackage() {



  const cardData = {
"keyword": "Pune Weekend Tour Packages",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune Weekend Tour Packages for travelers who want to take a short break from their busy routine and explore nearby destinations with ease. Whether you are planning a family getaway, romantic trip, friends’ outing, nature escape, beach holiday, or spiritual tour, our taxi-based packages ensure a smooth, flexible, and stress-free travel experience. With experienced drivers who are familiar with Maharashtra’s highways, ghats, and coastal routes, clean air-conditioned vehicles maintained for long-distance comfort, and transparent pricing with no hidden charges, we provide a dependable travel solution from Pune. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for all group sizes. With customizable itineraries, one-way and round-trip options, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a perfect weekend travel experience from Pune to multiple destinations.",

"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description":
      "Lonavala and Khandala are the most popular weekend hill stations near Pune known for lush green valleys, waterfalls, viewpoints, and pleasant weather. Attractions like Tiger Point, Bhushi Dam, and Rajmachi Fort make it a perfect quick escape for relaxation and nature lovers."
  },
  {
    "title": "Mahabaleshwar",
    "description":
      "Mahabaleshwar is a famous hill station known for its cool climate, strawberry farms, viewpoints like Arthur Seat and Wilson Point, and serene lakes. It is ideal for couples, families, and long scenic drives from Pune."
  },
  {
    "title": "Panchgani",
    "description":
      "Panchgani is a peaceful hill station near Mahabaleshwar known for Table Land, strawberry gardens, and panoramic valley views. It is perfect for a calm weekend retreat surrounded by nature."
  },
  {
    "title": "Alibaug",
    "description":
      "Alibaug is a popular coastal destination near Pune known for clean beaches, Kolaba Fort, and relaxed seaside vibes. It is ideal for beach lovers and short weekend trips."
  },
  {
    "title": "Matheran",
    "description":
      "Matheran is an eco-friendly hill station known for its toy train, no-vehicle policy, scenic viewpoints, and walking trails surrounded by dense forest and misty weather."
  },
  {
    "title": "Ganpatipule",
    "description":
      "Ganpatipule is a beautiful coastal pilgrimage destination known for its famous Ganpati temple and clean beaches. It offers a peaceful mix of spirituality and seaside relaxation."
  },
  {
    "title": "Tarkarli",
    "description":
      "Tarkarli is known for its crystal-clear waters, white sand beaches, and adventure activities like scuba diving and snorkeling. It is one of the best weekend beach destinations from Pune."
  },
  {
    "title": "Bhimashankar",
    "description":
      "Bhimashankar is a famous Jyotirlinga temple located in the Sahyadri hills, surrounded by dense forests and wildlife. It is perfect for spiritual and nature-focused weekend trips."
  },
  {
    "title": "Lavasa",
    "description":
      "Lavasa is a planned hill city known for its lakeside promenade, colorful buildings, and peaceful environment, making it a quick modern getaway near Pune."
  },
  {
    "title": "Konkan Coastal Scenic Route",
    "description":
      "Weekend tours from Pune often include scenic drives through the Western Ghats, lush green valleys, tunnels, waterfalls, and coastal highways, offering a refreshing travel experience filled with natural beauty and relaxation."
  }
],



services: [
  {
    name: "Pune Weekend Tour Cab",
    description: "Pune weekend tour cab service provides reliable transportation for travelers planning weekend getaways and sightseeing trips from Pune. Comfortable vehicles with experienced drivers ensure smooth highway travel for families, tourists, and groups. Pickup services are available from homes, hotels, railway stations, airport terminals, and offices across Pune. Vehicles include sedans, SUVs, Innova Crysta, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient weekend tour cab reservations."
  },
  {
    name: "Pune Weekend Travel Packages",
    description: "Pune weekend travel packages service offers comfortable transportation solutions for travelers planning short holiday trips and weekend vacations from Pune. Vehicles provide spacious seating and smooth travel suitable for tourism, hill station visits, beach holidays, and family outings. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient weekend travel package reservations."
  },
  {
    name: "Pune Weekend Trip Cab",
    description: "Pune weekend trip cab service provides dependable transportation for passengers planning short trips and outstation journeys from Pune. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth journeys to popular destinations. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune. Ideal for family vacations, sightseeing, and holiday travel requirements. Flexible booking options allow convenient weekend trip cab reservations."
  },
  {
    name: "Pune Weekend Sightseeing Cab",
    description: "Pune weekend sightseeing cab service offers reliable transportation with comfortable vehicles and professional drivers for exploring tourist destinations around Pune during weekends. Vehicles provide smooth highway and city travel suitable for tourism, sightseeing, shopping trips, and family outings. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow easy sightseeing cab reservations."
  },
  {
    name: "Pune Weekend Holiday Taxi",
    description: "Pune weekend holiday taxi service provides dependable transportation solutions for passengers traveling from Pune for short holiday vacations and leisure trips. Vehicles are suitable for city and highway travel ensuring safe and smooth journeys for individuals, families, and group travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for tourism, sightseeing, and holiday travel. Flexible booking options allow convenient holiday taxi reservations."
  },
  {
    name: "Pune Weekend Tour Service",
    description: "Pune weekend tour service provides transparent and reliable transportation for travelers visiting popular tourist attractions and nearby destinations from Pune during weekends. Travelers can enjoy comfortable journeys with experienced drivers familiar with popular travel routes and destinations. Comfortable vehicles ensure smooth travel with safe transportation services throughout the tour. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient weekend tour reservations."
  },
  {
    name: "Pune Weekend Outstation Cab",
    description: "Pune weekend outstation cab service provides economical and comfortable transportation for travelers planning outstation trips and weekend tours from Pune. Comfortable vehicles ensure smooth highway travel suitable for tourism, beach holidays, hill station visits, and family outings. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient outstation cab reservations."
  },
  {
    name: "Best Pune Weekend Packages Cab",
    description: "Best Pune weekend packages cab service offers convenient transportation for passengers planning weekend sightseeing and holiday trips from Pune. Comfortable vehicles provide smooth travel with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Ideal for local sightseeing, outstation tourism, and holiday visits. Flexible booking options allow convenient weekend package cab reservations."
  },
  {
    name: "Cheap Pune Weekend Cab",
    description: "Cheap Pune weekend cab service allows passengers to reserve affordable transportation for weekend trips and short holidays from Pune. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow economical weekend cab reservations."
  },
  {
    name: "SUV Pune Weekend Trip Cab",
    description: "SUV Pune weekend trip cab service provides spacious transportation for families and groups traveling from Pune for weekend tours and sightseeing trips. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for family outings and holiday travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient SUV trip cab reservations."
  },
  {
    name: "Innova Pune Weekend Tour Cab",
    description: "Innova Pune weekend tour cab service provides premium SUV transportation for passengers seeking comfortable and reliable weekend travel from Pune. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient Innova tour cab reservations."
  },
  {
    name: "Pune Weekend Getaway Taxi",
    description: "Pune weekend getaway taxi service offers economical and comfortable transportation for solo travelers, couples, and small families planning weekend vacations from Pune. Sedan and SUV vehicles provide smooth highway travel with comfortable seating and luggage space suitable for holiday journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient getaway taxi reservations."
  },
  {
    name: "Pune Weekend Travel Cab",
    description: "Pune weekend travel cab service offers dependable transportation for passengers planning weekend travel, tourism, and sightseeing trips from Pune. Comfortable vehicles ensure smooth and safe highway travel suitable for tourists, families, and business travelers. Professional chauffeurs ensure timely pickup and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient weekend travel cab reservations."
  },
  {
    name: "Pune Weekend Trip Booking Cab",
    description: "Pune weekend trip booking cab service provides reliable transportation booking options for passengers planning weekend holidays and sightseeing tours from Pune. Comfortable vehicles ensure smooth city and highway travel suitable for family vacations, tourism, and leisure travel. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow easy weekend trip cab reservations."
  },
  {
    name: "Pune Holiday Weekend Cab",
    description: "Pune holiday weekend cab service provides reliable transportation for passengers planning holiday tours and weekend vacations from Pune to nearby tourist destinations. Comfortable vehicles ensure smooth and safe travel suitable for sightseeing, beach holidays, hill station trips, and family vacations. Professional chauffeurs ensure punctual pickup and dependable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient holiday weekend cab reservations."
  }
],

tableData: [
  ["Pune Weekend Tour Cab", "Pune Weekend Travel Packages"],
  ["Pune Weekend Trip Cab", "Pune Weekend Sightseeing Cab"],
  ["Pune Weekend Holiday Taxi", "Pune Weekend Tour Service"],
  ["Pune Weekend Outstation Cab", "Best Pune Weekend Packages Cab"],
  ["Cheap Pune Weekend Cab", "SUV Pune Weekend Trip Cab"],
  ["Innova Pune Weekend Tour Cab", "Pune Weekend Getaway Taxi"],
  ["Pune Weekend Travel Cab", "Pune Weekend Trip Booking Cab"],
  ["Pune Holiday Weekend Cab", "Pune Weekend Tour Cab"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable Pune Weekend Tour Package Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune Weekend Tour package service with professional drivers, comfortable vehicles, and well-planned travel routes for smooth holiday experiences."
      },
      {
        WhyChooseheading: "Affordable Weekend Tour Taxi Packages",
        WhyChoosedescription: "Shivai Travels offers affordable Pune Weekend Tour package pricing with transparent fare details and no hidden charges. Customers receive complete travel package information before booking confirmation."
      },
      {
        WhyChooseheading: "24/7 Weekend Tour Cab Availability",
        WhyChoosedescription: "Our Pune Weekend Tour cab service operates 24 hours a day for family vacations, hill station trips, beach holidays, sightseeing tours, and customized weekend travel requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable long-distance travel experiences during weekend tours."
      },
      {
        WhyChooseheading: "Customized Weekend Tour Packages",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including Lonavala tours, Mahabaleshwar trips, Konkan beach holidays, temple tours, and customized weekend getaway packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for couples, families, tourists, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Tourist Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with popular tourist destinations near Pune and ensure smooth travel, safe driving, and timely arrival throughout the weekend tour."
      }
    ]
  };

  const faqData = [
    { question: "What are Pune Weekend Tour Packages?", answer: "Pune Weekend Tour Packages provide comfortable taxi transportation and travel plans for nearby hill stations, beaches, temples, and tourist destinations." },
    { question: "Are Pune Weekend Tour Packages available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune Weekend Tour cab services." },
    { question: "Which vehicles are available for weekend tours?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book customized weekend tour packages?", answer: "Yes, customers can book customized weekend travel packages according to their destination and travel requirements." },
    { question: "Which destinations are covered in Pune Weekend Tour Packages?", answer: "Shivai Travels covers destinations like Lonavala, Mahabaleshwar, Panchgani, Alibag, Konkan beaches, and temple tours." },
    { question: "Are all weekend tour taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable long-distance travel." },
    { question: "Can I book Pune Weekend Tour Packages online?", answer: "Yes, customers can easily book Pune Weekend Tour cab services online or through phone booking." },
    { question: "Do you provide cabs for family and group tours?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Pune Weekend Tour package fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune Weekend Tour Packages?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak tourist seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Akshay Kulkarni",
      feedback:
        "Booked Pune Weekend Tour package with Shivai Travels. Comfortable vehicle, smooth travel experience, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Poonam Patil",
      feedback:
        "Excellent Pune Weekend Tour taxi service. Affordable pricing, clean cab, and wonderful family vacation experience.",
      rating: 5
    }
  ];















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune Weekend Tour Packages Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-weekend-tour-cab.jpg",
  "description": "Book Pune Weekend Tour Packages cab service for comfortable short trips and weekend getaways. Shivai Travels offers customized weekend travel packages with sedan, SUV, Innova, and luxury cab options available 24x7 for hill stations, beaches, and nearby tourist destinations.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-weekend-tour-packages"
  }
};




  return (
    <div>

<Helmet>
  <title>Pune Weekend Tour Packages | Weekend Travel Cab | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune Weekend Tour Packages cab service for short trips and weekend getaways. Affordable travel packages with sedan, SUV, Innova, and luxury cabs available 24x7 for hill stations, beaches, and nearby destinations."
  />

  <meta
    name="keywords"
    content="pune weekend tour cab, pune weekend travel packages, pune weekend trip cab, pune weekend sightseeing cab, pune weekend holiday taxi, pune weekend tour service, pune weekend outstation cab, best pune weekend packages cab, cheap pune weekend cab, suv pune weekend trip cab, innova pune weekend tour cab, pune weekend getaway taxi, pune weekend travel cab, pune weekend trip booking cab, pune holiday weekend cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/93.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Puneweeendtourpackage;